import React from 'react';
import PropTypes from 'prop-types';
import FsHamburgerComponent from './FsHamburger.styles.js';
import {withSitecoreContext} from "@sitecore-jss/sitecore-jss-react";

const FsHamburger = ({ onClick, active, ...props }) => (

  <FsHamburgerComponent
    {...props}
    active={active}
    onClick={(event) => {
      if (typeof onClick === 'function') {
        onClick(event);
      }
    }}
    aria-label="toggle menu"
  >
    <span></span>
    <span></span>
  </FsHamburgerComponent>
);

FsHamburger.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

export default withSitecoreContext()(FsHamburger);